// ----
// Client StatsMaster
// Where we track all end-user actions like clicking on share tools, content panes, etc.
// ----


var SCM = SCM || {};

SCM.ClientStatsMaster = (function ($, undefined) {
    // ----
    // Private Functions and Variables go here
    // ----
    var resourceId = parseInt($('#hdnMultimediaId').val());
    var mediaGroupMultimediaTypeId = $('#hdnMediaGroupMultimediaTypeId').val();
    var guestAccessKey = $('#hdnGuestAccessKey').val();
    var $stdAloneMmMinosLogToken = $('#hdnStandaloneMultimediaPageViewMinosLogToken');

    function UserClientActionFilterType(key, value) {
        this.ActionFilterKey = key;
        this.ActionFilterValue = value;
    }

    function UserSessionItem(sessionId, clientId, siteId) {
        this.SessionID = sessionId;
        this.ClientID = clientId;
        this.SiteID = siteId;
    }

    function UserClientAction(filterKey, filterValue, actionDescription, url) {
        this.UserSessionItem = new UserSessionItem('', 0, $('#hdnSiteID').val());
        this.ActionFilterType = new UserClientActionFilterType(filterKey, filterValue);
        this.ActionDescription = actionDescription;
        this.ActionURL = url;
    }

    UserClientAction.prototype.toJson = function () {
        return JSON.stringify(this);
    };

    function sendClientTrackingData(filterKey, filterValue, actionDescription, url) {
        var data = new UserClientAction(filterKey, filterValue, actionDescription, url).toJson();
        var serviceUrl = '/ClientTrackingHandler.ashx';

        $.ajax({
            type: 'POST',
            url: serviceUrl,
            data: data,
            contentType: 'application/json; charset=utf-8',
            async: true,
            processData: true
        }).fail(function (jqXhr, textStatus) {
            if (window.console) {
                console.error('jqXhr.responseText: ' + jqXhr.responseText);
                console.error('status: ' + textStatus);
            }
        });
    }


    function sendPlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $playedElement)
    {        
        sendStatsR1PlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey);
        sendMinosPlayAction(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $playedElement);
    }

    function sendStatsR1PlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey) {
        var serviceUrl = '/UserActionStats/LogStatsForStandaloneMultimediaPlay';

        $.ajax({
            type: 'POST',
            url: serviceUrl,
            data: { MultimediaId: resourceId, MediaGroupMultimediaTypeId: mediaGroupMultimediaTypeId, GuestAccessKey: guestAccessKey }
        })
            .fail(function (jqXhr, textStatus) {
                if (window.console) {
                    console.error('jqXhr.responseText: ' + jqXhr.responseText);
                    console.error('status: ' + textStatus);
                }
            });
    }

    function sendMinosPlayAction(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $playedElement) {        
        var serviceUrl = '/UserActionStats/LogMinosStatsForStandaloneMultimediaPlay';

        if (!$stdAloneMmMinosLogToken.length) {
            return;
        }

        var stdAloneMmMinosLogTokenValue = $stdAloneMmMinosLogToken.val();

        var resourceMultimediaId = "";
        if ($playedElement && $playedElement.length) {
            resourceMultimediaId = $playedElement.closest('.js-multimedia-section').attr("data-resource-multimedia-id");
        } 

        var data = {
            MultimediaId: resourceId,
            MediaGroupMultimediaTypeId: mediaGroupMultimediaTypeId,
            GuestAccessKey: guestAccessKey,
            MinosEventLogToken: stdAloneMmMinosLogTokenValue,
            ResourceMultimediaId: resourceMultimediaId
        };

        SCM.Ajax.post(serviceUrl, data)
            .expectJson()            
            .catch(console.error);
    }

    function sendMinosLogForCookieAcceptance() {
        var serviceUrl = '/UserActionStats/LogMinosStatsForGDPRCookieAcceptAction';
        SCM.Ajax.post(serviceUrl)
            .expectJson()
            .catch(console.error);
    }

    // ----
    // Return an object exposed to the public
    // ----
    return {

        trackClickAction: function ($elem) {            
            $elem.on('click', function () {
                if (!$(this).data('clicked')) {
                    sendPlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $(this));
                    $(this).data('clicked', true);
                }
            });
        },

        trackPlayAction: function ($elem) {
            $elem.on('play', function () {
                if (!$(this).data('played')) {
                    sendPlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $(this));                    
                    $(this).data('played', true);
                }
            });
        },

        trackJwPlayerClickAction: function () {
            $('.jwplayer-wrapper').on('click', '.jwplayer', function () {
                if (!$(this).data('played')) {
                    sendPlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $(this));
                    $(this).data('played', true);
                }
            });
        },

        trackBrightCovePlayerClickAction: function () {
            $('.brightcove-wrapper-audio, .brightcove-wrapper').on('click', '.brightcove-player', function () {
                if (!$(this).data('played')) {
                    sendPlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $(this));
                    $(this).data('played', true);
                }
            });
        },

        trackSoundcloudPlayAction: function () {
            var widgetIframes = document.getElementsByClassName('soundcloud-embed');
            Array.prototype.forEach.call(widgetIframes, function (widgetIframe) {
                var widget = SC.Widget(widgetIframe);

                widget.bind(SC.Widget.Events.READY, function () {
                    widget.bind(SC.Widget.Events.PLAY, function () {
                        if (!$(this).data('played')) {
                            sendPlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $(widgetIframe));
                            $(this).data('played', true);
                        }
                    });
                });
            });
        },

        logPlayActionStats: function ($playedElement) {
            sendPlayActionTrackingData(resourceId, mediaGroupMultimediaTypeId, guestAccessKey, $playedElement);
        },

        // GDPR cookie acceptance logging
        trackGdprCookieAcceptance: function (gdprActionKey, actionValue, actionDescription) {
            sendClientTrackingData(gdprActionKey, actionValue, actionDescription, window.location.href);
            sendMinosLogForCookieAcceptance();
        }       
    };

})(jQuery);


$(window).on('load', function () {
    SCM.ClientStatsMaster.trackPlayAction($('div.podcast-player > audio'));
    SCM.ClientStatsMaster.trackSoundcloudPlayAction();
    SCM.ClientStatsMaster.trackClickAction($('.glencoe-video'));
    SCM.ClientStatsMaster.trackJwPlayerClickAction();
    SCM.ClientStatsMaster.trackBrightCovePlayerClickAction();
});